import React from 'react';
import { useStyletron } from 'baseui';
import { getChevronSlotStyle } from './styles';

/** Fixed-size placeholder that occupies the chevron slot for rows that can't expand. */
export const ChevronSpacer = () => {
  const [css, theme] = useStyletron();
  return <span className={css(getChevronSlotStyle(theme))} />;
};